<div mat-dialog-content>
    <div class="spinner-strict-sized-window">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="data.message">{{ data.message | translate }}</div>
</div>